module.exports = __webpack_public_path__ + "static/media/brazen_abelgas.1a0c16d9.jpeg";